import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { BaseTypography as o } from "../../../common/components/BaseStyledComponents/BaseTypography.js";
import { useTheme as r } from "@mui/joy";
import i from "@mui/joy/Stack";
const n = ({ label: n2, children: a, gap: l = 2, actions: p, ...m }) => {
  const s = r();
  return e(i, { sx: { border: (e2) => `1px solid ${e2.palette.neutral[300]}`, borderRadius: (e2) => e2.spacing(1), padding: 2, gap: l, height: "auto" }, ...m, children: [e(i, { direction: "row", justifyContent: "space-between", alignItems: "baseline", sx: { width: "100%", gap: 1 }, children: [n2 && t(o, { level: "title-md", fontWeight: 600, lightColor: s.palette.text.primary, children: n2 }), t(i, { direction: "row", gap: 1, alignItems: "center", children: p })] }), a] });
};
export {
  n as BarBox
};
//# sourceMappingURL=BarBox.js.map
